import api from "./api";

export function getCities(idState) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/departamentos/${idState}/ciudades`);
}
